import { configService } from "../../services/configService";
import hotelConfig from "../../config/companies/hotel";
import STOConfig from "../../config/companies/STO";

const EXISTING_CONFIGS = [
  {
    name: "Hotel Management",
    key: "hotel",
    description:
      "Hotel task management system with room blocks and departments",
    config: hotelConfig,
    isActive: true,
  },
  {
    name: "STO System",
    key: "STO",
    description: "Service station management system",
    config: STOConfig,
    isActive: true,
  },
];

export const migrateConfigsToFirestore = async () => {
  try {
    console.log("Starting configuration migration to Firestore...");

    for (const configData of EXISTING_CONFIGS) {
      try {
        // Check if configuration already exists
        const existingConfig = await configService.getConfigurationByKey(
          configData.key,
        );

        if (existingConfig) {
          console.log(
            `Configuration ${configData.key} already exists, skipping...`,
          );
          continue;
        }

        // Create new configuration
        const configId = await configService.createConfiguration(configData);
        console.log(
          `Created configuration ${configData.key} with ID: ${configId}`,
        );
      } catch (error) {
        console.error(
          `Error migrating configuration ${configData.key}:`,
          error,
        );
      }
    }

    console.log("Configuration migration completed!");
  } catch (error) {
    console.error("Error during configuration migration:", error);
  }
};

// Function to run migration from admin panel
export const runMigration = async () => {
  try {
    await migrateConfigsToFirestore();
    return { success: true, message: "Migration completed successfully" };
  } catch (error) {
    console.error("Migration failed:", error);
    return {
      success: false,
      message: "Migration failed: " + (error as Error).message,
    };
  }
};
